import React, {useEffect, useState} from "react";
import { RCCButton } from "react-common-components";

const styledButtonExpandOrCompressGroupers = `
	position: fixed;
	display: flex;
	align-items: center;
    bottom: 1.5rem;
    right: 1.5rem;
    z-index: 2000;
	padding: 0 4px;
`;

interface IButtonScrollTo{
	minHeightToShowButton: number;
	elementToScroll?: HTMLDivElement | null;
}

const ButtonScrollTo: React.FC<IButtonScrollTo> = ({
	elementToScroll,
	minHeightToShowButton
}) => {
	const [showButton, setShowButton] = useState(false);

	const scrollEvent = () => {
		if(window.pageYOffset > minHeightToShowButton){
			setShowButton(true);
			return;
		}
		if(window.pageYOffset < minHeightToShowButton)
			setShowButton(false);
	};

	useEffect(() => {
		document.addEventListener("scroll", scrollEvent);
		return () => {
			document.removeEventListener("scroll", scrollEvent);
		};
	}, []);

	if(!showButton)
		return null;

	return (
		<RCCButton
			icon={{name: "arrowUp", color: "#FFF", size: 26}}
			color="grey"
			layout="isRounded"
			size="md"
			onClick={() => {
				if(elementToScroll && elementToScroll != null){
					elementToScroll.scrollIntoView({behavior: "smooth", block: "start" });
					return;
				}
				window.scrollTo(0, 0);
			}}
			styleInline={styledButtonExpandOrCompressGroupers}
		/>
	);
};

export default ButtonScrollTo;
